// extracted by mini-css-extract-plugin
module.exports = {"callout":"i_er","header":"i_es","icon":"i_et","description":"i_eu"};